import Vue from 'vue'
import { Notification, Icon } from 'element-ui'

Vue.use(Icon)
Vue.prototype.$notify = Notification
